import { parse } from 'papaparse';
import { AllInputData, DaySettingData } from '../types/AllInputData.types';

const config = {
  header: true,
  skipEmptyLines: true,
};
export const getDataFromCSV = async () => {
  const dataSource = {
    technologyData: await (await fetch('/data/technology_data.csv')).text(),
    allDayData: await (await fetch('/data/day_data.csv')).text(),
    // dayTypeData:
    optionsData: await (await fetch('/data/options.csv')).text(),
    simplifiedData: await (await fetch('/data/simplified.csv')).text(),
  };

  const daySettingsDataFetch = async (num: number) =>
    await (await fetch(`/data/day_type_${num}.csv`)).text();

  const { data: technologyData } = parse(dataSource.technologyData, config);
  const { data: allDayData } = parse<AllInputData['allDayData'][number]>(
    dataSource.allDayData,
    config
  );
  const { data: optionsData } = parse<{ option: string; value: string }>(
    dataSource.optionsData,
    config
  );
  const { data: simplifiedData } = parse<{
    option: string;
    cost: string;
    emissions: string;
    security: string;
  }>(dataSource.simplifiedData, config);

  const result = {
    technologyData: technologyData.map((row) =>
      convertStringToNumbers(row as Record<string, unknown>)
    ),
    allDayData: allDayData.map((row) =>
      convertStringToNumbers(row as Record<string, unknown>)
    ),
    simplifiedData: { cost: {}, emissions: {}, security: {} },
    dayTypeData: {},
    optionsData: {},
  } as unknown as Partial<AllInputData>;

  //Simplified Data
  const columnHeadings = ['cost', 'emissions', 'security'];

  columnHeadings.forEach((columnHeading) => {
    for (const row of simplifiedData) {
      //@ts-ignore
      const value: string = row[columnHeading];

      if (!isNaN(parseFloat(value)) && isFinite(Number(value))) {
        //@ts-ignore
        result.simplifiedData[columnHeading][row.option] = parseFloat(value); // convert to integer if value is a number
      } else {
        //@ts-ignore
        result.simplifiedData[columnHeading][row.option] = value;
      }
    }
  });

  //All Day Data
  for (const row of allDayData) {
    let value = +row.yearPercentage; // redefine object to day_title: value
    //@ts-ignore
    result.dayTypeData[row.name] = value;
  }

  // Day Settings Data
  result.daySettingsData = (await Promise.all(
    Array(8)
      .fill('')
      .map(async (_, index) => {
        const { data } = parse<{ [key: number]: string }>(
          await daySettingsDataFetch(index),
          config
        );

        const newData = data.map((row) =>
          Object.values(row).map((item) => Number(item))
        );

        return newData;
      })
  )) as DaySettingData[];

  //Option Data
  for (const row of optionsData) {
    let value = row.value;

    if (!isNaN(Number(row.value))) {
      //@ts-ignore
      result.optionsData[row.option] = parseFloat(row.value); // convert to integer if value is a number
    } else {
      //@ts-ignore
      result.optionsData[row.option] = value;
    }
  }

  result.megsData = [];
  result.megsTechnologies = [];
  console.log(result);

  return result;
};

function convertStringToNumbers(obj: Record<string, unknown>) {
  // Create a new object to store the converted values
  const result: Record<string, unknown> = {};

  // Iterate through the properties of the input object
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];

      // Check if the value is a valid number in string format
      if (!isNaN(Number(value))) {
        // Convert the string to a number and store it in the result object
        result[key] = Number(value);
      } else {
        // If it's not a valid number, keep the original value
        result[key] = value;
      }
    }
  }

  return result;
}
